import OkReportDeveloperPesquisa from './OkReportDeveloperPesquisa'
import enhance from './OkReportDeveloperPesquisa.enhancer'

export default enhance(OkReportDeveloperPesquisa)



// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/components/OkReportDeveloperPesquisa/index.js